// extracted by mini-css-extract-plugin
export default {"hyperlinksField":"HyperlinksField_hyperlinksField__oOP2n","linksList":"HyperlinksField_linksList__x2B8O"};